import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import CookieBanner from "./Components/CookieBanner/CookieBanner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RootLayout() {
  useEffect(() => {
    // 1. Disable right-click globally
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // 2. Disable text copying except in form inputs, textareas, and contenteditable elements
    const handleCopy = (e) => {
      const target = e.target;
      if (
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.tagName === "SELECT" ||
          target.isContentEditable)
      ) {
        return; // Allow copying text inside form fields
      }
      e.preventDefault();
    };

    // 3. Disable image dragstart globally (prevent dragging images to save/search them)
    const handleDragStart = (e) => {
      if (e.target && e.target.tagName === "IMG") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("dragstart", handleDragStart);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Outlet />
      <CookieBanner />
      <ToastContainer />
    </>
  );
}

